import React from 'react';
import { Text, Overlay, LoadingBalls } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import { Mode } from '../useLineItemMutations';

import './LineItemOverlay.scss';

interface Props {
  item: LineItem;
  mode: Mode;
  show: boolean;
}

export const LineItemOverlay: React.FC<Props> = ({ item, mode, show }) => (
  <Overlay show={show}>
    {mode === Mode.Deleting && (
      <>
        <LoadingBalls />

        <Text treatment="eyebrow">Deleting</Text>
      </>
    )}

    {mode === Mode.Updating && (
      <>
        <LoadingBalls />

        <Text treatment="eyebrow">Saving</Text>
      </>
    )}

    {mode === Mode.Deleted && (
      <div className="LineItemOverlay__deleted-message">
        {item.attributes.productName} has been removed.
      </div>
    )}
  </Overlay>
);
